import { render } from "./MainSanPhamThueHuongDan.vue?vue&type=template&id=0ba6368e&scoped=true"
import script from "./MainSanPhamThueHuongDan.vue?vue&type=script&lang=js"
export * from "./MainSanPhamThueHuongDan.vue?vue&type=script&lang=js"

import "./MainSanPhamThueHuongDan.vue?vue&type=style&index=0&id=0ba6368e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba6368e"]])

export default __exports__